const MATTER_TOKEN_QUERY_PARAM = "matter_token"
const MATTER_EXPIRES_QUERY_PARAM = "matter_token_exp"

export function isSubdomain(urlStr: string): boolean {
  const url = new URL(urlStr)
  if (location.protocol.toLocaleLowerCase() !== url.protocol.toLocaleLowerCase()) {
    return false
  }

  if (location.port !== url.port && !import.meta.env.DEV) {
    return false
  }

  return url.hostname.toLocaleLowerCase().endsWith(`.${location.hostname.toLocaleLowerCase()}`)
}

export function appendTokenParams(urlStr: string | URL, token: string, expires: number): string {
  try {
    const url = typeof urlStr === "string" ? new URL(urlStr) : urlStr
    url.searchParams.set(MATTER_TOKEN_QUERY_PARAM, token)
    url.searchParams.set(MATTER_EXPIRES_QUERY_PARAM, expires.toString())

    return url.toString()
  } catch {
    return urlStr.toString()
  }
}

export function removeTokenParams(urlStr: string): string {
  try {
    const url = new URL(urlStr)
    url.searchParams.delete(MATTER_TOKEN_QUERY_PARAM)
    url.searchParams.delete(MATTER_EXPIRES_QUERY_PARAM)

    return url.toString()
  } catch {
    return urlStr
  }
}